import { axios } from '@/services/axios';

export const getData = async (apiUrl, headers) => {
    const res = await axios.get(apiUrl, { headers });
    return res.data;
};
